import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import cn from 'classnames';
import { Box } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import styles from './WithLegendDot.module.scss';
export const GetWithLegendDotTID = (parentTestId)=>getTestIds(parentTestId);
export function WithLegendDot(props) {
    const { children, color, isHollow, className, testId } = props, rest = _object_without_properties(props, [
        "children",
        "color",
        "isHollow",
        "className",
        "testId"
    ]);
    const { WithLegendDotTestIds } = useMemo(()=>GetWithLegendDotTID(testId), [
        testId
    ]);
    const dotStyle = isHollow ? {
        borderColor: color
    } : {
        backgroundColor: color
    };
    return /*#__PURE__*/ _jsxs(Box, _object_spread_props(_object_spread({
        className: cn(styles.root, className),
        testId: testId
    }, rest), {
        children: [
            /*#__PURE__*/ _jsx(Box, {
                className: cn(styles.dot, !!isHollow && styles.hollow),
                style: dotStyle,
                testId: WithLegendDotTestIds.Dot()
            }),
            children
        ]
    }));
}
